<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <div
        class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent">

        <div class="flex-1 min-w-0">
            <div>
                <div class="flex">
                    <a class="inline-flex items-center -ml-1.5 text-secondary font-medium"
                        [routerLink]="'/profile-dashboard'">
                        <mat-icon class="icon-size-5 text-secondary"
                            [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                        <span class="ml-1">Back</span>
                    </a>
                </div>
            </div>
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    {{ isStaffView ? 'Profile' : 'Admin Profile' }}
                </h2>
            </div>
        </div>

        <!-- Hide Add Admin or Add Staff buttons when viewing staff -->
        <div class="flex shrink-0 items-center sm:ml-4">
            <button class="ml-3" mat-flat-button [routerLink]="'/membership-form'" [color]="'primary'"
                *ngIf="!isStaffView && dataSource.length === 0">
                Add Admin
            </button>
        </div>

        <div class="flex shrink-0 items-center sm:ml-4">
            <button class="ml-3" mat-flat-button [routerLink]="'/staff-form'" [color]="'primary'"
                *ngIf="!isStaffView && dataSource.length === 1">
                Add Staff
            </button>
        </div>
    </div>

    <div class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card" cdkScrollable>
        <div *ngIf="dataSource.length === 0"
            class="w-full py-4 text-center font-bold text-lg text-gray-600 dark:text-gray-300">
            No Administrator found.
        </div>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-full" *ngIf="dataSource.length > 0">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Administrator Name </th>
                <td mat-cell *matCellDef="let element" class="clickable" (click)="onNameClick(element)">
                    {{ element?.Administrator_Name__c }}
                </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element">{{ element?.Email__c }}</td>
            </ng-container>

            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef> Phone </th>
                <td mat-cell *matCellDef="let element">{{ element?.Phone__c }}</td>
            </ng-container>

            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef> Role </th>
                <td mat-cell *matCellDef="let element">{{ element?.Role__c }}</td>
            </ng-container>
            <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef> City </th>
                <td mat-cell *matCellDef="let element">{{ element?.Town_City__c }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['name', 'email', 'phone', 'role', 'city']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['name', 'email', 'phone', 'role', 'city'];"></tr>
        </table>

    <br>

    <div class="mt-2">
        <h3 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
            Staff
        </h3>

        <div *ngIf="dataSourceStaff.length === 0"
            class="w-full py-4 text-center font-bold text-lg text-gray-600 dark:text-gray-300">
            No staff found.
        </div>
    </div>
        <table mat-table [dataSource]="dataSourceStaff" class="mat-elevation-z8 w-full"
            *ngIf="dataSourceStaff.length > 0"> <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Staff Name </th>
                <td mat-cell *matCellDef="let element" class="clickable" (click)="navigateToStaffDetail(element)">
                    {{ element?.Staff_Name__c }} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element">{{ element?.Staff_Email__c }}</td>
            </ng-container>

            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef> Phone </th>
                <td mat-cell *matCellDef="let element">{{ element?.Staff_Phone__c }}</td>
            </ng-container>

            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef> Role </th>
                <td mat-cell *matCellDef="let element">{{ element?.Role__c }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element">
                    <div class="flex items-center gap-2">
                        <span [ngClass]="{
          'text-[#7cbd4a] font-semibold': element?.Is_Active__c,
          'text-red-400': !element?.Is_Active__c
        }">
                            {{ element?.Is_Active__c ? 'Active' : 'Inactive' }}
                        </span>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['name', 'email', 'phone', 'role', 'status']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['name', 'email', 'phone', 'role', 'status'];"></tr>
        </table>
    </div>
</div>

